import { BaseFiltroPagDTO } from "./base-dto";

export class EstadoClinicoFiltroDTO extends BaseFiltroPagDTO {
    nome: string;
    ativo: Boolean;
}

export class EstadoClinicoDTO {
    id: number;
    nome: string;
    descricao: string;
    ativo: boolean;
}

export class EstadoClinicoParm {
    id: number;
    nome: string;
    descricao: string;
    ativo: boolean;
}